import React from 'react'
import ErrorPage from './ErrorPage'

export * from './ErrorPage'
export default React.memo(ErrorPage)
